import { useTheme } from 'bold-ui'
import { TickProps } from 'bold-ui/lib/components/Chart/Tick'
import moment, { Moment } from 'moment'

export interface TickIdadeProps extends TickProps {
  dataNascimento: Moment
  shouldRenderPreTermo?: boolean
}

export function TickIdade(props: Readonly<TickIdadeProps>) {
  const {
    payload: { value: dataMedicao },
    dataNascimento,
    shouldRenderPreTermo = false,
    ...rest
  } = props

  const theme = useTheme()

  const MS_POR_SEMANA = 7 * 24 * 60 * 60 * 1000
  const idade = moment.duration(moment(dataMedicao).diff(dataNascimento, 'months'), 'months')
  const isAno = !shouldRenderPreTermo && !idade.months() && !idade.weeks() && !idade.days()

  const label = (() => {
    if (shouldRenderPreTermo) {
      const diffMs = dataMedicao.valueOf() - dataNascimento.valueOf()
      return Math.round(diffMs / MS_POR_SEMANA)
    }
    if (isAno) return idade.years()
    return idade.months()
  })()

  return (
    <text
      {...rest}
      dy={15}
      fill={isAno ? theme.pallete.text.main : undefined}
      style={isAno ? { fontWeight: 'bold', fontSize: '1rem' } : undefined}
    >
      {label}
    </text>
  )
}
